import { createBrowserRouter } from 'react-router-dom';
import { Shell } from './shell/Shell';
import { Dashboard } from './shell/Dashboard';
import { AnalysesPage } from './views/AnalysesPage';
import { NormsPage } from './views/NormsPage';
import { GroupsPage } from './views/GroupsPage';
import { UnitsPage } from './views/UnitsPage';
import { ContextsPage } from './views/ContextsPage';
import { DeviationsPage } from './views/DeviationsPage';
import { TextRulesPage } from './views/TextRulesPage';
import { MaterialsPage } from './views/MaterialsPage';
import { OcrAnalysePage } from './views/OcrAnalysePage';
import { SpecializationsPage } from './views/Specializations';
import { AccessDeniedPage } from './views/AccessDeniedPage';
import { AuthGuard } from './auth/AuthGuard';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AuthGuard><Shell /></AuthGuard>,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'analyses', element: <AnalysesPage /> },
      { path: 'norms', element: <NormsPage /> },
      { path: 'groups', element: <GroupsPage /> },
      { path: 'units', element: <UnitsPage /> },
      { path: 'contexts', element: <ContextsPage /> },
      { path: 'deviations', element: <DeviationsPage /> },
      { path: 'text-rules', element: <TextRulesPage /> },
      { path: 'materials', element: <MaterialsPage /> },
      { path: 'specializations', element: <SpecializationsPage /> },
      { path: 'ocr-analyse', element: <OcrAnalysePage /> },
    ],
  },
  {
    path: '/access-denied',
    element: <AccessDeniedPage />,
  },
]);


